import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Config
import PRConfig from "components/Stacker/config/ProductConfiguratorConfig"

// Utils
import { getS7ConfigUrl } from "lib/utils/productConfig-util"

// components
import Icon from "components/Stacker/components/Icon/Icon"

// Styles
import "./Step3Motif.scss"
import { useState } from "react"
import { useEffect } from "react"
import { useRef } from "react"
import { useI18nContext } from "i18n/i18n-react"

function Step3Motif({
  setContainerHeight,
  setScroll,
  containerNode,
  metal,
  design,
  icon,
  setMotifStep,
  theme,
  configTypeValue,
  nextStep,
}) {
  const node = useRef()
  const { LL } = useI18nContext()
  const [selectedCat, set_selectedCat] = useState("")

  useEffect(() => {
    const updateHeight = () => {
      const computedHeight = getComputedStyle(node.current).height
      setContainerHeight(computedHeight)
    }

    setScroll(containerNode)
    setTimeout(() => {
      setContainerHeight(getComputedStyle(node.currentTarget).height)
    }, 300)
    window.addEventListener("resize", updateHeight)
    return () => window.removeEventListener("resize", updateHeight)
  }, [containerNode])

  const selectedCategory = (e) => {
    const { value } = e.currentTarget
    if (selectedCat === value) {
      set_selectedCat = ""
    } else {
      set_selectedCat = value
    }
  }

  const iconSet = PRConfig.ICON_VALUES[0]

  const imgUrl = getS7ConfigUrl(configTypeValue, theme, metal)

  return (
    <div className="pinky-wrap" ref={node}>
      <div className="container">
        <div
          className={`config-step-content config-${metal}-step3 config-step-content__${design}`}
        >
          <h2
            id="step-title"
            className="text-center config-step-content__step-title"
          >
            {LL.productConfig.selectMotifText()}
          </h2>

          <div className="app-js__product-config">
            <div className="row d-flex align-items-end">
              <div className="col-12 col-xl-7 product-config-container">
                <div className="step-img-container">
                  <img
                    src={`${imgUrl}${icon.toLowerCase()}?$productConfigPDP_desktop$`}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-12 col-xl-5 config-module-container d-flex align-self-end ">
                <div className="w-100">
                  {Object.keys(iconSet).map((key, catIndex) => (
                    <div key={`${key}-key`} className="category-group">
                      <div className="category-group__title d-flex justify-content-between">
                        <button
                          value={key}
                          className="w-100 hover-transition d-flex justify-content-between"
                          onClick={selectedCategory}
                        >
                          <h6 className="category-group__title-text">{key}</h6>
                          <div className="icon-container_drawer-icons">
                            <div
                              className={classNames({
                                show: selectedCat === key,
                                "d-none": selectedCat !== key,
                              })}
                            >
                              <Icon iconName="icon-minus" />
                            </div>

                            <div
                              className={classNames({
                                show: selectedCat !== key,
                                "d-none": selectedCat === key,
                              })}
                            >
                              <Icon iconName="icon-plus" />
                            </div>
                          </div>
                        </button>
                      </div>
                      <div
                        className={classNames("category-group__options", {
                          expanded: selectedCat === key,
                          closed: selectedCat !== key,
                        })}
                      >
                        <div className="category-group__options-item">
                          {iconSet[key].map((iconVal, iconIndex) => (
                            <button
                              key={`${iconVal.name}-key`}
                              value={iconVal.value}
                              data-motifcode={iconVal.code}
                              onClick={setMotifStep}
                              className={classNames(
                                "category-group__options-item-font-btn col-2",
                                {
                                  selected: icon === iconVal.value,
                                }
                              )}
                            >
                              <Icon
                                additionalClassNames="category-group__options-item-icons"
                                iconName={`icon-${iconVal.value.toLowerCase()}`}
                              />
                              <p className="category-group__options-item-label">
                                {iconVal.name}
                              </p>
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    className="category-group__options-next-btn c-btn d-flex align-items-center justify-content-center hover-transition"
                    disabled={!icon}
                    aria-disabled={!icon}
                    onClick={nextStep}
                  >
                    {LL.productConfig.nextText()}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Step3Motif.propTypes = {
  setMotifStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func,
  metal: PropTypes.string.isRequired,
  design: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  setContainerHeight: PropTypes.func.isRequired,
  setScroll: PropTypes.func,
  containerNode: PropTypes.node,
  configTypeValue: PropTypes.string,
}

export default Step3Motif
